export const getStatusColor = (status: string) => {
  switch (status) {
    case 'Draft':
      return 'border-transparent bg-black text-white hover:bg-black/80';
    case 'Scheduled':
      return 'border-transparent bg-gray-300  text-black hover:bg-gray-300/80';
    case 'Sent':
      return 'border-transparent bg-green-200  text-black hover:bg-green-200/80';
    default:
      return 'border-transparent bg-gray-200  text-black hover:bg-gray-200/80';
  }
};
